import { GlobalPairIndicatorSet } from '@/types/GlobalPairIndicatorSet';
import type { GetterTree } from 'vuex';

import {RootState} from "@/store";

export interface GlobalPairIndicatorSetsState {
  globalPairIndicatorSets: GlobalPairIndicatorSet[];
}

const state: GlobalPairIndicatorSetsState = {
  globalPairIndicatorSets: [],
};

const getters: GetterTree<GlobalPairIndicatorSetsState, RootState> = {
  getGlobalPairIndicatorSets: (state) => state.globalPairIndicatorSets,
  getGlobalPairIndicatorSetById: (state) => (idGlobalPair: number, idIndicatorSet: number) => {
    return state.globalPairIndicatorSets.find(
      (globalPairIndicatorSet: GlobalPairIndicatorSet) => globalPairIndicatorSet.idGlobalPair === idGlobalPair && globalPairIndicatorSet.idIndicatorSet === idIndicatorSet
    );
  },

};

const mutations = {
  wsSetGlobalPairIndicatorSets(state: GlobalPairIndicatorSetsState, payload: { globalPairIndicatorSets: any }) {
    const arr: any[] = [];
    const sets = payload.globalPairIndicatorSets;
    if (sets && typeof sets === 'object') {
      Object.keys(sets).forEach(idGlobalPair => {
        const indicatorSets = sets[idGlobalPair];
        if (indicatorSets && typeof indicatorSets === 'object') {
          Object.keys(indicatorSets).forEach(idIndicatorSet => {
            const indicatorSet = indicatorSets[idIndicatorSet];
            arr.push({
              idGlobalPair: Number(idGlobalPair),
              idIndicatorSet: Number(idIndicatorSet),
              ...indicatorSet,
            });
          });
        }
      });
    }
    state.globalPairIndicatorSets = arr.map(globalPairIndicatorSet => GlobalPairIndicatorSet.fromRaw(globalPairIndicatorSet));
  },
  wsGlobalPairIndicatorSetCreate(state: GlobalPairIndicatorSetsState, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    const newGlobalPairIndicatorSet = new GlobalPairIndicatorSet(payload.idGlobalPair, payload.idIndicatorSet);
    state.globalPairIndicatorSets.push(newGlobalPairIndicatorSet);
  },
  wsGlobalPairIndicatorSetUpdate(state: GlobalPairIndicatorSetsState, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    const index = state.globalPairIndicatorSets.findIndex(
      globalPairIndicatorSet => globalPairIndicatorSet.idGlobalPair === payload.idGlobalPair && globalPairIndicatorSet.idIndicatorSet === payload.idIndicatorSet
    );
    if (index !== -1) {
      state.globalPairIndicatorSets[index] = new GlobalPairIndicatorSet(payload.idGlobalPair, payload.idIndicatorSet);
    }
  },
  wsGlobalPairIndicatorSetDelete(state: GlobalPairIndicatorSetsState, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    const index = state.globalPairIndicatorSets.findIndex(
      globalPairIndicatorSet => globalPairIndicatorSet.idGlobalPair === payload.idGlobalPair && globalPairIndicatorSet.idIndicatorSet === payload.idIndicatorSet
    );
    if (index !== -1) {
      state.globalPairIndicatorSets.splice(index, 1);
    }
  },
  clearGlobalPairIndicatorSets(state: GlobalPairIndicatorSetsState) {
    state.globalPairIndicatorSets = [];
  },
};

const actions = {
  wsSetGlobalPairIndicatorSets({ commit }: any, payload: { globalPairIndicatorSets: any }) {
    commit('wsSetGlobalPairIndicatorSets', payload);
  },
  wsGlobalPairIndicatorSetCreate({ commit }: any, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    commit('wsGlobalPairIndicatorSetCreate', payload);
  },
  wsGlobalPairIndicatorSetUpdate({ commit }: any, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    commit('wsGlobalPairIndicatorSetUpdate', payload);
  },
  wsGlobalPairIndicatorSetDelete({ commit }: any, payload: { idGlobalPair: number; idIndicatorSet: number }) {
    commit('wsGlobalPairIndicatorSetDelete', payload);
  },
  clearGlobalPairIndicatorSets({ commit }: any) {
    commit('clearGlobalPairIndicatorSets');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}; 